import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Box, Button, TextField, Typography, FormControl, Select, MenuItem, FormHelperText } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { UserMasterType } from "../DataFetch/useUserMaster";
import { AuthorityMasterType, useAuthorityMaster } from "../DataFetch/useAuthorityMaster";
import { useContext } from "react";
import { SessionContext } from "../ManagementRoot";
import { useErrorDialog } from "../Component/useErrorDialog";
import { useConfirmDialog } from "../Component/useConfirmDialog";
import { PostAddUser, PostDeleteUser, PostUpdateUser } from "../DataFetch/ManagementAPI";

interface FormInputType {
    loginId:string,
    password:string,
    userName:string,
    authorityId:number
}

interface PropsType {
    editData:UserMasterType | undefined,
    CompleteEdit:() => void,
    setEditing:(editing:boolean) => void    
}

export function UserMasterEdit({editData, CompleteEdit, setEditing}:PropsType) {

    const isNew = editData === undefined ? true : false

    const {authorityMaster} = useAuthorityMaster();

    const ConfirmSession = useContext(SessionContext);

    const {openErrorDialog, ErrorDialog} = useErrorDialog();

    const {waitConfirm, ConfirmDialog} = useConfirmDialog();

    const {control, handleSubmit } = useForm<FormInputType>({
        defaultValues:{
            loginId: editData?.login_id,
            password: "",
            userName: editData?.user_name,
            authorityId: editData?.authority_id
        }
    });

    async function onSubmit(data:FormInputType) {

        if(!await ConfirmSession()) {
            return;
        }

        await waitConfirm("保存します。よろしいですか？")
        .then(res => {
            if(res) {
                if(isNew) {
                    PostAddUser({
                        loginId: data.loginId,
                        password: data.password,
                        userName: data.userName,
                        authorityId: data.authorityId
                    })
                    .then(res => {
                        res ? CompleteEdit() : openErrorDialog();
                    })
                } else {
                    PostUpdateUser({
                        userId: Number(editData?.user_id),
                        loginId: editData?.login_id,
                        password: data.password,
                        userName: data.userName,
                        authorityId: data.authorityId,
                    })
                    .then(res => {
                        res ? CompleteEdit() : openErrorDialog();
                    })
                }
            }
        })
    }

    async function DeleteUser() {

        if(!await ConfirmSession()) {
            return;
        }

        await waitConfirm("削除します。よろしいですか？")
        .then(res => {
            res && PostDeleteUser(editData?.user_id) 
            .then(res => {
                res ? CompleteEdit() : openErrorDialog();
            })
        })
    }

    return(
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                    <Grid2 xs={12} sm="auto">
                        <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"left"}}}>
                            ログインID
                        </Typography>  
                    </Grid2>
                    <Grid2 xs={12} sm={2}>
                        <Controller
                            name="loginId"
                            control={control}
                            rules={{
                                required:"必須項目です。",
                                maxLength: {
                                    value: 30,
                                    message:"30文字以下にしてください。"
                                }
                            }}
                            render={({field,fieldState}) => (
                                <TextField 
                                    fullWidth
                                    {...field} 
                                    error={fieldState.invalid}
                                    helperText={fieldState.error?.message}
                                    disabled={!isNew}
                                />
                            )}
                        />
                    </Grid2>
                </Grid2>
                <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                    <Grid2 xs={12} sm="auto">
                        <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"left"}}}>
                            パスワード
                        </Typography>  
                    </Grid2>
                    <Grid2 xs={12} sm={2}>
                        <Controller
                            name="password"
                            control={control}
                            rules={{
                                required:"必須項目です。",
                                maxLength: {
                                    value: 30,
                                    message:"30文字以下にしてください。"
                                }
                            }}
                            render={({field,fieldState}) => (
                                <TextField 
                                    fullWidth
                                    {...field} 
                                    error={fieldState.invalid}
                                    helperText={fieldState.error?.message}
                                    type="password"
                                />
                            )}
                        />
                    </Grid2>
                </Grid2>

                <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                    <Grid2 xs={12} sm="auto">
                        <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"left"}}}>
                            ユーザー名
                        </Typography>  
                    </Grid2>
                    <Grid2 xs={12} sm={2}>
                        <Controller
                            name="userName"
                            control={control}
                            rules={{
                                required:"必須項目です。",
                                maxLength: {
                                    value: 30,
                                    message:"30文字以下にしてください。"
                                }
                            }}
                            render={({field,fieldState}) => (
                                <TextField 
                                    fullWidth
                                    {...field} 
                                    error={fieldState.invalid}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                    </Grid2>
                </Grid2>

                <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                    <Grid2 xs={12} sm="auto">
                        <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"left"}}}>
                            {"権限　　　"}
                        </Typography>  
                    </Grid2>
                    <Grid2 xs={12} sm={2}>
                        <Controller
                            name="authorityId"
                            control={control}
                            rules={{required:"必須項目です。"}}
                            render={({field,fieldState}) => (
                                <FormControl fullWidth error={fieldState.invalid}>
                                    <Select {...field} sx={{textAlign:"left"}}>
                                        {authorityMaster?.map((item:AuthorityMasterType,index:number) => (
                                            <MenuItem key={index} value={item.authority_id}>{item.authority_name}</MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText>{fieldState.error?.message}</FormHelperText>
                                </FormControl>
                            )}
                        />
                    </Grid2>
                </Grid2>

                <Box m={1}>
                    <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                        <Grid2>
                            <Button variant="outlined" onClick={() => setEditing(false)}>
                                戻る
                            </Button>
                        </Grid2>
                        <Grid2>
                            <Button type="submit" variant="contained">
                                保存
                            </Button>
                        </Grid2>
                        <Grid2 display={isNew ? "none" : ""}>
                            <Button variant="contained" color="error"
                                onClick={DeleteUser}
                            >
                                削除
                            </Button>
                        </Grid2>                     
                    </Grid2>
                </Box>  
            </form>

            <ErrorDialog/>
            <ConfirmDialog/>
        </>
    );
}